import React from "react";
import { useTranslation } from "react-i18next";
import ThemeFullscreenBar from "./FullScreenBar";
import TabContainer from "../../../../../components/components/TabContainer";
import { Card, Spinner } from "@shopify/polaris";
import { QuestionMarkInverseMinor } from "@shopify/polaris-icons";

export default function ThemeTemplatesSkeleton(props) {
  const { t } = useTranslation();
  
  return (
    <div className="Theme-Template__Wrapper">
      <ThemeFullscreenBar
        returnURL="/themes/live"
        saveAction={{ loading: true }}
        discardAction={{ loading: true }}
      />
      <TabContainer
        useLastPath
        sections={[
          {
            title: t("themes.templates.categories.templates"),
            items: [
              { label: t("themes.templates.items.landing") },
              { label: t("themes.templates.items.directory") },
              { label: t("themes.templates.items.country") },
              { label: t("themes.templates.items.region") },
              { label: t("themes.templates.items.city") },
              { label: t("themes.templates.items.location") },
            ],
          },
          {
            title: t("themes.templates.categories.schemas"),
            separator: true,
            items: [{ label: t("themes.templates.items.language") }, { label: t("themes.templates.items.settings") }],
          },
          {
            title: t("themes.templates.categories.styles"),
            separator: true,
            items: [{ label: t("themes.templates.items.stylesheet") }],
          },
          {
            separator: true,
            items: [],
            fill: true,
          },
          {
            separator: true,
            items: [
              {
                label: t("themes.templates.categories.liquidReference"),
                icon: QuestionMarkInverseMinor,
              },
            ],
          },
        ]}
      >
        <div className="template-page">
          <Card.Section>
            <div
              style={{
                display: "flex",
                alignItems: "center",
                justifyContent: "center",
                height: "100%",
              }}
            >
              <Spinner size="large" />
            </div>
          </Card.Section>
        </div>
      </TabContainer>
    </div>
  );
}
